import { render, staticRenderFns } from "./MessageLetterList.vue?vue&type=template&id=1d2f3766&scoped=true&"
import script from "./MessageLetterList.vue?vue&type=script&lang=js&"
export * from "./MessageLetterList.vue?vue&type=script&lang=js&"
import style0 from "./MessageLetterList.vue?vue&type=style&index=0&id=1d2f3766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2f3766",
  null
  
)

export default component.exports